import { render } from "./edit_consumer.vue?vue&type=template&id=22391694"
import script from "./edit_consumer.vue?vue&type=script&lang=js"
export * from "./edit_consumer.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__